module.exports = __webpack_public_path__ + "static/media/bh.834467b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bh.svg
// module id = 64
// module chunks = 0